import React from 'react';
import MuiButton from '@mui/material/Button';
import { colors, fonts } from '../theme/index.js';

/**
 *
 * @param {*} props
 */
const Button = props => {
  const {
    onClick,
    customStyle,
    className,
    variant,
    transparent,
    marginTop,
    marginBottom,
    children,
    disabled,
    fullWidth,
    color = "default",
    id,
    testid,
    noHover,
    tabIndex,
    component
  } = props;

  /**
   *
   * @returns
   */
  const setHoverColor = () => {
    if (noHover) {
      return null;
    }
    if (color === "white") {
      return "#d5d5d5";
    }
    return color === "default" && colors.hoverGrey;
  };

  /**
   *
   * @returns the styles to be applied if the transparent prop is applied to the component
   */
  const setTransparentStyles = () => {
    if (transparent) {
      return {
        width: fullWidth ? '100%' : 'fit-content',
        boxShadow: 'none',
        backgroundColor: colors.clear,
        fontSize: fonts.size.label,
        paddingLeft: '10px',
        paddingRight: '10px',
        color: colors.darkBlue,
        '&:hover': {
          backgroundColor: "#d5d5d5"
        }
      };
    }
    return {};
  };
  const style = {
    textTransform: "none",
    fontFamily: fonts.type.heading,
    letterSpacing: "0.02857em",
    whiteSpace: "nowrap",
    marginTop: marginTop || 0,
    marginBottom: marginBottom || 0,
    width: fullWidth ? "100%" : "auto",
    transition: className && 'all 0.2s ease',
    '&:hover': {
      backgroundColor: setHoverColor()
    },
    ...setTransparentStyles(),
    ...customStyle
  };
  if (color === 'white') {
    style.backgroundColor = "#FFF";
  }
  return /*#__PURE__*/React.createElement(MuiButton, {
    id: id || testid,
    color: color,
    disabled: disabled,
    variant: variant || "contained",
    sx: style,
    onClick: onClick,
    tabIndex: tabIndex,
    component: component || null
  }, children);
};
export default Button;